import React from 'react';
import { Box, Group } from '@mantine/core';
import { TypingIndicatorProps } from '../../types/assistant';
import classes from './TypingIndicator.module.css';

/**
 * TypingIndicator Component
 * Displays an animated indicator showing the assistant is typing
 * Supports 3 animation variants: dots, wave, and pulse
 */
export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  isVisible,
  color = 'cyberOrange',
  variant = 'dots'
}) => {
  if (!isVisible) {
    return null;
  }

  const dotColor = `var(--mantine-color-${color}-6)`;

  switch (variant) {
    case 'wave':
      return (
        <Box className={classes.typingIndicator} data-variant="wave">
          <div className={classes.wave} style={{ '--dot-color': dotColor } as React.CSSProperties}>
            <span className={classes.waveDot}></span>
            <span className={classes.waveDot}></span>
            <span className={classes.waveDot}></span>
            <span className={classes.waveDot}></span>
          </div>
        </Box>
      );

    case 'pulse':
      return (
        <Box className={classes.typingIndicator} data-variant="pulse">
          <div className={classes.pulse} style={{ '--dot-color': dotColor } as React.CSSProperties}>
            <span className={classes.pulseDot}></span>
          </div>
        </Box>
      );

    case 'dots':
    default:
      return (
        <Box className={classes.typingIndicator} data-variant="dots">
          <Group gap={4}>
            <div
              className={classes.dot}
              style={{ '--dot-color': dotColor } as React.CSSProperties}
            ></div>
            <div
              className={classes.dot}
              style={{ '--dot-color': dotColor, animationDelay: '0.15s' } as React.CSSProperties}
            ></div>
            <div
              className={classes.dot}
              style={{ '--dot-color': dotColor, animationDelay: '0.3s' } as React.CSSProperties}
            ></div>
          </Group>
        </Box>
      );
  }
};

TypingIndicator.displayName = 'TypingIndicator';
